import {VideoPokerCardCombinationName} from "./VideoPokerCardCombinationName";

export class VideoPokerCardCombination {
    constructor(private combinationName: VideoPokerCardCombinationName, private combinationPositions: Array<number>) {

    }

    public getName(): VideoPokerCardCombinationName {
        return this.combinationName;
    }

    public getPositions(): Array<number> {
        return this.combinationPositions;
    }
}



// WEBPACK FOOTER //
// ./src/app/VideoPokerCardCombination.ts